export default __webpack_public_path__ + "static/media/Re-liquefaction plant_V.3.601790b3.png";